<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12 sm10 md4>
      <router-view></router-view>
    </v-flex>
  </v-layout>
</template>

<style scoped>
/*#sign-in-card {
      position: absolute;
      right: 15px;
      top: 85px;
      width: 30%;
  }*/
</style>
<script type="text/javascript">
export default {
  name: 'Auth',
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Auth.vue